import { Flex, Text } from "@chakra-ui/react";
import { useSetRecoilState, useRecoilState } from "recoil";
import { BLUEMONEDDBUTTONS } from "../../../../constants/colors";

export default function TitleFlex({ item }: any) {
  return (
    <Flex mx={2} mt={4} mb={3} borderBottom={`solid 3px ${BLUEMONEDDBUTTONS}`}>
      <Text color={BLUEMONEDDBUTTONS} fontWeight={"bold"}>
        {item && item}
      </Text>
    </Flex>
  );
}
